import { createSelector } from '@ngrx/store';
import { TMachineMaintenanceState } from '../reducers';
import { TSparePartListState } from './sparepart-list.models';

export const getSparePartListState = (state: TMachineMaintenanceState) => state.sparePartServiceInfo;

export const getSparePartListInfo = createSelector(
  getSparePartListState,
  (state: TSparePartListState) => state.sparePartListingInfo,
);

export const getSparePartRequestListInfo = createSelector(
  getSparePartListState,
  (state: TSparePartListState) => state.sparePartRequestListingInfo,
);

export const getSparepartListPagination = createSelector(
  getSparePartListState,
  (state: TSparePartListState) => state.sparePartListingPagination,
);

export const getSparepartRequestPagination = createSelector(
  getSparePartListState,
  (state: TSparePartListState) => state.sparePartRequestPagination,
);
